<div class="p-grid grid">
  <div class="p-col-12 p-lg-6" style="margin: 0 auto;margin-bottom: 30px;">
    <div class="p-grid buttons-container">
      <div fxLayout="column" fxLayoutAlign="space-evenly center" class="button-container">
        <div class="p-col-12">
          <div class="p-col-12" style="margin-bottom: 50px">
            <div class="nextButtonWrapper">
              <button pButton class="button" style="min-width: 300px"
                [label]="translateService.instant('Current Year Competition', { year: surveyConfig.currentYear })"
                [routerLink]="['/current-competition']"></button>
            </div>
          </div>

          <div class="nextButtonWrapper">
            <button pButton class="button-gray" style="min-width: 300px"
              [label]="translateService.instant('Previous Year Competition', { year: surveyConfig.previousYear })"
              [routerLink]="['/previous-competition']"></button>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>
